import * as moment from 'moment'

export const defaultDateFormat = "MMM DD, yyyy-HH:mm"

export function parseDate(dateString :string, timeZone: string):Date
{
    return moment.tz(dateString, defaultDateFormat, timeZone).toDate();
}
